import { Button, Card, Col, Flex, Row, Select, Tabs } from 'antd';
import React, { useEffect, useState } from 'react';
import IntlMessage from '../../components/IntlMessage';
import Statistics from './Statistics';
import Route from './Route';
import operatorsApi from '../../api/operators';
import { useIntl } from 'react-intl';

const { Option } = Select;
const Trips = () => {
  const [operator, setOperator] = useState(null);
  const [operator_id, setOperatorId] = useState('');
  const intl = useIntl();
  const filterOperator = {
    page: 1,
    limit: 100,
    order_by: 'id',
    order_dir: 'ASC',
  };
  useEffect(() => {
    const fetch = async () => {
      try {
        let operator = await operatorsApi.getAll(filterOperator);
        setOperator(operator.data);
      } catch (e) {
        console.error(e);
      } finally {
      }
    };
    fetch();
  }, []);

  const onChangeOperator = (value) => {
    setOperatorId(value);
  };

  const tabs = [
    {
      key: '1',
      label: <IntlMessage id="global.statistics" />,
      children: (
        <Statistics
          operator_id={operator_id}
          operator={
            operator && operator.find((item) => item.id === operator_id)
          }
        />
      ),
    },
    {
      key: '2',
      label: <IntlMessage id="global.routes" />,
      children: <Route operator_id={operator_id} />,
    },
  ];
  return (
    <Card>
      <Flex justify="center">
        <Select
          // mode={item.type}
          showSearch
          placeholder={<IntlMessage id="global.operator" />}
          onChange={onChangeOperator}
          style={{ width: '20%', display: 'flex', justifyContent: 'center' }}
          allowClear={true}
          optionFilterProp="children"
          filterOption={(input, option) => {
            if (typeof option.children !== 'string') {
              if (option?.children?.props?.id) {
                return (
                  intl
                    .formatMessage({ id: option?.children?.props?.id })
                    ?.toLowerCase()
                    ?.indexOf(input?.toLowerCase()) >= 0
                );
              } else {
                return (
                  option.value?.toLowerCase()?.indexOf(input?.toLowerCase()) >=
                  0
                );
              }
            }
            return (
              option?.children?.toLowerCase()?.indexOf(input?.toLowerCase()) >=
              0
            );
          }}>
          {operator?.length &&
            operator?.map((option, i) => {
              return (
                <Option key={i} value={option?.id ? option?.id : ''}>
                  {option?.title || option?.display}
                </Option>
              );
            })}
        </Select>
      </Flex>
      <Tabs
        defaultActiveKey="1"
        type="line"
        size="large"
        items={tabs}
        centered
        destroyInactiveTabPane={true}
      />
    </Card>
  );
};

export default Trips;
